export default {
  namespaced: true,
  state: {
    accountTypeKey: [
      { key: 1, value: "ui.member" },
      { key: 2, value: "ui.agent" },
      { key: 3, value: "ui.master" },
      { key: 4, value: "ui.senior" },
      { key: 5, value: "ui.super_senior" },
      { key: 6, value: "ui.share_holder" }
    ]
  },
  getters: {
    getAccountTypeByKey: state => {
      return sKey =>
        state.accountTypeKey.reduce((result, accountTypeKey) => {
          if (accountTypeKey.key === sKey) {
            result = accountTypeKey.value;
          }
          return result;
        }, sKey);
    }
  }
};
